module.exports = __webpack_public_path__ + "img/A58A0393_min.ea17a4ab.jpg";